<ngx-loading-bar [includeSpinner]="false" color="#dd2610"></ngx-loading-bar>
<router-outlet></router-outlet>
